"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthGateUrl = exports.getResetPasswordRedirect = exports.setResetPasswordRedirect = exports.getEnv = exports.setEnv = exports.setDomain = exports.getDomain = exports.getClientId = exports.setClientId = exports.Environment = exports.config = void 0;
exports.config = {
    test: {
        authGateUrl: 'https://gateway.test.cheggnet.com/auth-gate/',
        jerichoUrl: 'https://trunk.live.test.cheggnet.com',
    },
    prod: {
        authGateUrl: 'https://gateway.chegg.com/auth-gate/',
        jerichoUrl: 'https://www.chegg.com',
    },
};
var Environment;
(function (Environment) {
    Environment["test"] = "test";
    Environment["prod"] = "prod";
})(Environment = exports.Environment || (exports.Environment = {}));
let oneAuthEnv = Environment.test;
let domainUrl;
let clientId;
let resetPasswordRedirect = '';
function setClientId(id) {
    clientId = id;
}
exports.setClientId = setClientId;
function getClientId() {
    return clientId;
}
exports.getClientId = getClientId;
function getDomain() {
    return domainUrl;
}
exports.getDomain = getDomain;
function setDomain(domain) {
    domainUrl = domain;
}
exports.setDomain = setDomain;
function setEnv(newEnv) {
    oneAuthEnv = newEnv;
}
exports.setEnv = setEnv;
function getEnv() {
    return oneAuthEnv;
}
exports.getEnv = getEnv;
function setResetPasswordRedirect(url) {
    resetPasswordRedirect = url;
}
exports.setResetPasswordRedirect = setResetPasswordRedirect;
function getResetPasswordRedirect() {
    return resetPasswordRedirect;
}
exports.getResetPasswordRedirect = getResetPasswordRedirect;
function getAuthGateUrl() {
    return exports.config[oneAuthEnv].authGateUrl;
}
exports.getAuthGateUrl = getAuthGateUrl;
